// import('import/js/perfect-scrollbar.jquery.js');

/* tslint:disable */
interface JQuery {
    perfectScrollbar(options: any): Object;
}
/* tslint:enable */

jQuery(function($) {
    $('.js-perfect-scrollbar').each(function() {
        $(this).perfectScrollbar({
            wheelPropagation: true,
        });
    });
});
